import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CustomFieldDto, ExportVisualDataTableFormat, FilterDto, LocaleDto, PdfPaperSize, VisualDto, VisualExportFileFormat, VisualService } from 'src/app/services/api.services';
import { VisualFileExportDialogComponent, VisualFileExportDialogData } from './visual-data-export-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class VisualFileExportDialogService {
  constructor(
    private dialog: MatDialog,
    private visualService: VisualService) { }

  public openDialog(options: VisualFileExportDialogOptions, title: string) {
    return this.dialog.open(VisualFileExportDialogComponent, {
      width: '520px',
      minHeight: '500px',
      disableClose: true,
      data: <VisualFileExportDialogData>{ options, title }
    });
  }
}


export interface VisualFileExportDialogOptionsVisualId {
  visualId: number;
}

export interface VisualFileExportDialogOptionsVisualDto {
  visual: VisualDto;
}

export interface VisualFileExportDialogOptionsAdditional {
  format?: VisualExportFileFormat;
  paperSize?: PdfPaperSize;
  includeHeader?: boolean;
  includeFooter?: boolean;
  filters?: FilterDto[];
  customFields?: CustomFieldDto[];
  renderUnshared?: boolean;
  tableFormat?: ExportVisualDataTableFormat;
  canIncludeChartImage?: boolean;
  locale?: LocaleDto;
}

export type VisualFileExportDialogOptions = (
  VisualFileExportDialogOptionsVisualId |
  VisualFileExportDialogOptionsVisualDto
) & VisualFileExportDialogOptionsAdditional;
